import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { GlobalService } from "./global.service";
import { CookieService } from "./cookie.service";
import { AuthService } from "./auth.service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class ResponseInterceptorService implements HttpInterceptor {
  curl="";
  constructor(public globalService: GlobalService, 
    public authService: AuthService,
    private router: Router,
    public cookie: CookieService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.curl=req.url.toLowerCase();
   
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
         
        }
        if((event['body'])&&(event['body']['error'])){
         this.authService.logout();
        }

        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        
          let data = {};
          data = {
              reason: error && error.error && error.error.reason ? error.error.reason : '',
              status: error.status
          };

          if( error.status==401){

            this.authService.logout(window.location.href);
            return throwError(error);
          }

         

          if((data['status']!=400)&&(this.curl.indexOf('cambiapasswordprimaria')<=0)){
            this.authService.logout();
          }
          if((this.curl.indexOf('cambiapasswordprimaria')>0)){
            this.globalService.changePasswordMessage.push(
              {severity: 'error', detail: 'Errore: password non accettata'
            });
          }
          if((this.curl.indexOf('resetpassword')>0)){
            this.globalService.changePasswordMessage.push(
              {severity: 'error', detail: 'Errore: utente non trovato'
            });
          }
          return throwError(error);
      })
    );
  }
}
